import React, { useState } from 'react';
import { Plus, Pencil, Trash2, X, Paperclip, FileText, Download } from 'lucide-react';
import { toast } from '../utils/toast';
import { anexoPerdido, baixarAnexo } from '../utils/anexo';
import { mascararCnpj, cnpjValido, cnpjFormatado } from '../utils/cnpj';

const lerArquivo = (file) => new Promise((resolve) => {
  const reader = new FileReader();
  reader.onload = (e) => resolve({ nome: file.name, dados: e.target.result });
  reader.readAsDataURL(file);
});


const FORM_VAZIO ={ nome: '', cnpj: '', email: '', valorHora: '', dataContratacao: '', responsavelFinanceiro: '', emailFinanceiro: '', anexos: [] };

export function Clientes({ clientes, setClientes }) {
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm]               = useState(FORM_VAZIO);
  const [editandoId, setEditandoId]   = useState(null);
  const [erroCnpj, setErroCnpj]       = useState('');

  const abrirNovo = () => { setErroCnpj(''); setForm(FORM_VAZIO); setEditandoId(null); setModalAberto(true); };
  const abrirEdicao = (c) => {
    setForm({ nome: c.nome||'', cnpj: cnpjFormatado(c.cnpj), email: c.email||'', valorHora: c.valorHora||'', dataContratacao: c.dataContratacao||'', responsavelFinanceiro: c.responsavelFinanceiro||'', emailFinanceiro: c.emailFinanceiro||'', anexos: c.anexos||[] });
    setErroCnpj('');
    setEditandoId(c.id);
    setModalAberto(true);
  };
  const fechar = () => { setModalAberto(false); setEditandoId(null); };

  const salvar = () => {
    if (!form.nome) return;
    // CNPJ é opcional; se preenchido, precisa fechar os dígitos verificadores.
    if (form.cnpj && !cnpjValido(form.cnpj)) {
      setErroCnpj('CNPJ inválido. Confira os números informados.');
      toast.aviso('CNPJ inválido. Confira os números informados.');
      return;
    }
    if (editandoId) {
      setClientes(clientes.map(c => c.id === editandoId ? { ...c, ...form } : c));
      toast.sucesso('Cliente atualizado com sucesso!');
    } else {
      setClientes([...clientes, { ...form, id: Date.now(), contratos: [] }]);
      toast.sucesso('Cliente cadastrado com sucesso!');
    }
    fechar();
  };

  const excluir = (id) => {
    if (window.confirm('Excluir este cliente?')) {
      setClientes(clientes.filter(c => c.id !== id));
      toast.sucesso('Cliente excluído.');
    }
  };

  return (
    <div className="m-container" style={s.container}>
      <div style={s.header}>
        <h2 style={s.titulo}>Clientes</h2>
        <button style={s.btnNovo} onClick={abrirNovo}><Plus size={16}/> Novo Cliente</button>
      </div>

      <div className="mobile-grid-1" style={s.grid}>
        {clientes.map(c => (
          <div key={c.id} style={s.card}>
            <div style={s.cardHeader}>
              <div>
                <div style={s.cardNome}>{c.nome}</div>
                {c.cnpj && <div style={s.cardEmail}>CNPJ {cnpjFormatado(c.cnpj)}</div>}
                <div style={s.cardEmail}>{c.email || 'Sem e-mail'}</div>
              </div>
              <div style={s.acoes}>
                <button style={s.btnEdit} onClick={() => abrirEdicao(c)}><Pencil size={15}/></button>
                <button style={s.btnDel} onClick={() => excluir(c.id)}><Trash2 size={15}/></button>
              </div>
            </div>
            {(c.anexos||[]).length > 0 && (
              <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                {(c.anexos||[]).map((a, i) => (
                  <button key={i} style={{ display:'flex', alignItems:'center', gap:5, background:'rgba(139,92,246,0.1)', border:'1px solid rgba(139,92,246,0.3)', borderRadius:20, color:'#8b5cf6', fontSize:11, padding:'3px 10px', cursor:'pointer' }}
                    title={anexoPerdido(a) ? 'O arquivo não está mais salvo. Anexe novamente.' : undefined}
                    onClick={() => baixarAnexo(a)}>
                    <Download size={12}/> {a.nome}{anexoPerdido(a) && ' (arquivo perdido)'}
                  </button>
                ))}
              </div>
            )}
            <div style={s.cardInfo}>
              <div style={s.infoLinha}>
                <span style={s.infoLabel}>Valor/Hora</span>
                <span style={s.infoValor}>R$ {parseFloat(c.valorHora||0).toLocaleString('pt-BR', {minimumFractionDigits:2, maximumFractionDigits:2})}</span>
              </div>
              <div style={s.infoLinha}>
                <span style={s.infoLabel}>Resp. Financeiro</span>
                <span style={s.infoTexto}>{c.responsavelFinanceiro || '—'}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {modalAberto && (
        <div style={s.overlay} onClick={fechar}>
          <div className="mobile-modal" style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <h3 style={s.modalTitulo}>Cliente</h3>
              <button style={s.modalFechar} onClick={fechar}><X size={18}/></button>
            </div>
            <div style={s.campo}>
              <label style={s.label}>Nome *</label>
              <input type="text" style={s.input} placeholder="Nome da empresa" value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} />
            </div>
            <div style={s.campo}>
              <label style={s.label}>CNPJ</label>
              <input type="text" inputMode="numeric" style={{ ...s.input, ...(erroCnpj ? { borderColor:'#ef4444' } : {}) }} placeholder="00.000.000/0000-00"
                value={form.cnpj}
                aria-invalid={!!erroCnpj}
                onChange={e => { setErroCnpj(''); setForm({...form, cnpj: mascararCnpj(e.target.value)}); }}
                onBlur={() => { if (form.cnpj && !cnpjValido(form.cnpj)) setErroCnpj('CNPJ inválido. Confira os números informados.'); }} />
              {erroCnpj && <span style={{ fontSize:12, color:'#ef4444' }}>{erroCnpj}</span>}
            </div>
            {[
              { label: 'E-mail', key: 'email', type: 'email', placeholder: 'email@exemplo.com' },
              { label: 'Valor por Hora (R$) *', key: 'valorHora', type: 'number', placeholder: '0,00' },
              { label: 'Data de Contratação', key: 'dataContratacao', type: 'date' },
              { label: 'Responsável Financeiro', key: 'responsavelFinanceiro', type: 'text', placeholder: 'Nome do responsável' },
              { label: 'E-mail Financeiro', key: 'emailFinanceiro', type: 'email', placeholder: 'financeiro@empresa.com' },
            ].map(f => (
              <div key={f.key} style={s.campo}>
                <label style={s.label}>{f.label}</label>
                <input type={f.type} style={s.input} placeholder={f.placeholder} value={form[f.key]} onChange={e => setForm({...form, [f.key]: e.target.value})} />
              </div>
            ))}
            <div style={s.campo}>
              <label style={s.label}>Contratos / Documentos</label>
              <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', flexWrap:'wrap' }}>
                <label style={{ display:'flex', alignItems:'center', gap:6, background:'transparent', border:'1px dashed #e5e0ef', borderRadius:8, color:'#5f5874', padding:'8px 14px', fontSize:12, cursor:'pointer' }}>
                  <Paperclip size={14}/> Adicionar arquivo(s)
                  <input type="file" accept=".pdf,.doc,.docx,.png,.jpg" multiple style={{display:'none'}} onChange={async (e) => {
                    const files = Array.from(e.target.files);
                    if (!files.length) return;
                    const resultados = await Promise.all(files.map(lerArquivo));
                    setForm(f => ({ ...f, anexos: [...(f.anexos||[]), ...resultados] }));
                    e.target.value = '';
                  }} />
                </label>
              </div>
              {(form.anexos||[]).length > 0 && (
                <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginTop:4 }}>
                  {(form.anexos||[]).map((a, i) => (
                    <span key={i} style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, color:'#8b5cf6', background:'rgba(139,92,246,0.1)', border:'1px solid rgba(139,92,246,0.3)', borderRadius:20, padding:'3px 10px' }}>
                      <FileText size={12}/> {a.nome}{anexoPerdido(a) && ' (arquivo perdido)'}
                      <button style={{ background:'transparent', border:'none', color:'#8b5cf6', cursor:'pointer', fontSize:14, lineHeight:1, padding:'0 2px', fontWeight:700 }}
                        onClick={() => setForm(f => ({ ...f, anexos: (f.anexos||[]).filter((_,j)=>j!==i) }))}>×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className="mobile-modal-footer" style={s.modalFooter}>
              {editandoId && <button style={s.btnExcluir} onClick={() => { excluir(editandoId); fechar(); }}>Excluir</button>}
              <button style={s.btnCancelar} onClick={fechar}>Cancelar</button>
              <button style={s.btnSalvar} onClick={salvar}>{editandoId ? 'Salvar alterações' : 'Salvar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  container: { display:'flex', flexDirection:'column', gap:'1.5rem' },
  header: { display:'flex', justifyContent:'space-between', alignItems:'center' },
  titulo: { fontSize:'1.8rem', fontWeight:700, color:'#1c1530' },
  btnNovo: { display:'flex', alignItems:'center', gap:6, background:'#7c3aed', color:'white', border:'none', borderRadius:20, padding:'9px 20px', fontSize:13, fontWeight:600, cursor:'pointer' },
  grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:'1rem' },
  card: { background:'#ffffff', border:'1px solid #e5e0ef', borderRadius:12, padding:'1.25rem', display:'flex', flexDirection:'column', gap:'0.75rem' },
  cardHeader: { display:'flex', justifyContent:'space-between', alignItems:'flex-start' },
  cardNome: { fontSize:16, fontWeight:700, color:'#1c1530' },
  cardEmail: { fontSize:13, color:'#5f5874', marginTop:2 },
  acoes: { display:'flex', gap:6 },
  btnEdit: { background:'transparent', border:'none', color:'#8b5cf6', cursor:'pointer', padding:4, display:'flex' },
  btnDel: { background:'transparent', border:'none', color:'#ef4444', cursor:'pointer', padding:4, display:'flex' },
  cardInfo: { background:'#f7f5fb', borderRadius:8, padding:'0.75rem', display:'flex', flexDirection:'column', gap:'0.5rem' },
  infoLinha: { display:'flex', justifyContent:'space-between', alignItems:'center' },
  infoLabel: { fontSize:12, color:'#5f5874' },
  infoValor: { fontSize:14, fontWeight:700, color:'#10b981' },
  infoTexto: { fontSize:13, color:'#1c1530' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'1rem' },
  modal: { background:'#ffffff', border:'1px solid #e5e0ef', borderRadius:14, padding:'1.5rem', width:'100%', maxWidth:480, display:'flex', flexDirection:'column', gap:'1rem', maxHeight:'90vh', overflowY:'auto' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center' },
  modalTitulo: { color:'#1c1530', fontSize:18, fontWeight:700 },
  modalFechar: { background:'transparent', border:'none', color:'#5f5874', cursor:'pointer', display:'flex' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:'0.75rem', marginTop:'0.5rem' },
  campo: { display:'flex', flexDirection:'column', gap:6 },
  label: { fontSize:12, fontWeight:600, color:'#5f5874', textTransform:'uppercase', letterSpacing:'0.05em' },
  input: { background:'#f7f5fb', border:'1px solid #e5e0ef', borderRadius:8, color:'#1c1530', padding:'9px 12px', fontSize:14, outline:'none', width:'100%' },
  btnExcluir: { background:'transparent', border:'1px solid #ef4444', borderRadius:8, color:'#ef4444', cursor:'pointer', padding:'8px 16px', fontSize:13, marginRight:'auto' },
  btnCancelar: { background:'transparent', border:'1px solid #e5e0ef', borderRadius:8, color:'#5f5874', cursor:'pointer', padding:'8px 16px', fontSize:13 },
  btnSalvar: { background:'#7c3aed', border:'none', borderRadius:8, color:'white', cursor:'pointer', padding:'8px 18px', fontSize:13, fontWeight:600 },
};
